var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 0 23)",
    fill: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.5H17",
    stroke: "#727272",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2242_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66583 3.33302V10.7797L12.9192 7.52635C13.1792 7.26635 13.6058 7.26635 13.8658 7.52635C14.1258 7.78635 14.1258 8.20635 13.8658 8.46635L9.4725 12.8597C9.2125 13.1197 8.7925 13.1197 8.5325 12.8597L4.1325 8.47302C3.8725 8.21302 3.8725 7.79302 4.1325 7.53302C4.3925 7.27302 4.8125 7.27302 5.0725 7.53302L8.3325 10.7797V3.33302C8.3325 2.96635 8.6325 2.66635 8.99917 2.66635C9.36583 2.66635 9.66583 2.96635 9.66583 3.33302Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2242_1394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 1 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.7449a5a469a3787c2be319d20f5a98c7.svg";
export { ForwardRef as ReactComponent };